import s from './Header.module.scss';
import React, {useEffect, useState} from 'react';
import logo from '../../assets/images/header.png';
import {useLocation, useNavigate} from 'react-router-dom';
import WeatherWidget from "./WeatherWidget";
import SearchOverlay from "./SearchOvrlay";

const Header = () => {
    const location = useLocation();
    const [cartCount, setCartCount] = useState(0);

    useEffect(() => {
        const updateCartCount = () => {
            const cart = JSON.parse(
                localStorage.getItem('booking_cart') || '[]'
            );

            setCartCount(cart.length);
        };

        // initial load
        updateCartCount();

        // update from other browser tabs
        window.addEventListener(
            'storage',
            updateCartCount
        );

        // update in same tab
        window.addEventListener(
            'cartUpdated',
            updateCartCount
        );

        return () => {
            window.removeEventListener(
                'storage',
                updateCartCount
            );

            window.removeEventListener(
                'cartUpdated',
                updateCartCount
            );
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        const params = new URLSearchParams(location.search);

        setKeyword(params.get("kw") || "");
    }, [location.search]);

    const [menuOpen, setMenuOpen] = useState(false);
    const navigate = useNavigate();
    const [searchOpen, setSearchOpen] = useState(false);
    const [keyword, setKeyword] = useState("");

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };


    const handleLogoClick = () => {
        navigate('/');
    };
    const handleSearchToggle = () => {
        setSearchOpen(prev => !prev);
    };

    const handleSearch = (e) => {
        if (e.key === "Enter") {
            updateSearchParam(keyword);
        }
    };
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    const handleSearchSubmit = () => {
        if (!keyword.trim()) updateSearchParam(keyword);
        ;
        updateSearchParam(keyword);
    };
    const updateSearchParam = (value) => {
        const params = new URLSearchParams(window.location.search);

        if (value && value.trim()) {
            params.set("kw", value);
            params.set("page", 1);
        } else {
            params.delete("kw"); // ✅ remove
            params.set("page", 1);
        }

        navigate({
            pathname: "/all-tours",
            search: params.toString()
        });
    };

    return (
        <nav className={`${s.navbar} navbar navbar-expand-lg ${s.navBgColor}`}>
            <div className="container">

                {/* LOGO */}
                <button
                    className="navbar-brand border-0 bg-transparent"
                    onClick={handleLogoClick}
                >
                    <img className={s.logo} src={logo} alt="ジェイさんツアーロゴ"/>
                </button>

                {/* MOBILE TOGGLE */}
                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#navbarText"
                    onClick={toggleMenu}
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                {/* MENU */}
                <div
                    className={`collapse navbar-collapse ${menuOpen ? 'show' : ''} ${searchOpen && !isMobile ? s.hideMenu : ''}`}>

                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">

                        <li className="nav-item">
                            <button className="nav-link active btn btn-link" onClick={() => navigate('/')}>
                                ホーム
                            </button>
                        </li>

                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => navigate('/all-tours')}>
                                ツアー
                            </button>
                        </li>

                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => navigate('/howto')}>
                                予約手続き
                            </button>
                        </li>

                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => navigate('/contact')}>
                                現地オフィス
                            </button>
                        </li>

                        <li className="nav-item">
                            <button className="nav-link btn btn-link" onClick={() => navigate('/faqs')}>
                                よくある質問
                            </button>
                        </li>

                        <li className="nav-item">
                            <button className="nav-link btn btn-link">
                                特別オファー
                            </button>
                        </li>

                    </ul>

                    {/* RIGHT SIDE */}
                    <div className="d-flex align-items-center gap-3">

                        {/* MOBILE → always show input */}
                        {isMobile ? (
                            <div className={s.searchBoxMobile}>
                                <input
                                    type="text"
                                    placeholder="ツアーを検索…"
                                    value={keyword}
                                    onChange={(e) => setKeyword(e.target.value)}
                                    onKeyDown={handleSearch}
                                />
                            </div>
                        ) : (
                            /* DESKTOP → toggle search */
                            <div className={s.searchContainer}>
                                <button className={s.searchIcon} onClick={handleSearchToggle}>
                                    <i className="fa fa-search"></i>
                                </button>
                                <SearchOverlay
                                    open={searchOpen}
                                    onClose={() => setSearchOpen(false)}
                                />

                            </div>
                        )}
                        <div
                            className={s.cartButton}
                            onClick={() => navigate('/cart')}
                        >
                            <i className="fa fa-cart-shopping"></i>

                            {cartCount > 0 && (
                                <span className={s.cartBadge}>
            {cartCount}
        </span>
                            )}
                        </div>
                        {/* Hide weather ONLY on desktop search open */}
                        {<WeatherWidget/>}


                    </div>

                </div>
            </div>


        </nav>
    );
};

export default Header;
